import { CustomNavbar } from "./custom";
import { LLNavbar } from "./ll/ll";
export var navbar = function (args) {
    var _a;
    if ((_a = args === null || args === void 0 ? void 0 : args.composer) === null || _a === void 0 ? void 0 : _a.template) {
        return new CustomNavbar(args);
    }
    else {
        return new LLNavbar(args);
    }
};
